import { createTheme } from "@mui/material/styles";
import PoppinsRegular from "../assets/fonts/Poppins/Poppins-Regular.ttf";
import PoppinsMedium from "../assets/fonts/Poppins/Poppins-Medium.ttf";

const themeMain = createTheme({
  palette: {
    primary: {
      main: "#1A281F",
    },
    secondary: {
      main: "#7DCAAF",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: "'Poppins-Medium', sans-serif",
  },
  components: {
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { boxShadow: "none", borderBottom: "none" } },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { boxShadow: "none" } },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { boxShadow: "none" } },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Poppins-Regular';
          font-style: normal;
          font-weight: normal;
          src: url(${PoppinsRegular}) format('truetype');
        }
        @font-face {
          font-family: 'Poppins-Medium';
          font-style: normal;
          font-weight: normal;
          src: url(${PoppinsMedium}) format('truetype');
        }

        body {
          font-family: 'Poppins-Medium', sans-serif;
        }
      `,
    },
  },
});

export default themeMain;
